import classNames from 'classnames';
import { FC } from 'react';

import { Contacts } from '@/entities/contacts';

import styles from './courierCard.module.scss';

interface CourierCardProps {
  selected: boolean;
  className?: string;
  contacts?: Contacts;
}

const CourierCard: FC<CourierCardProps> = (props) => {
  const { selected = false, className, contacts } = props;

  return (
    <div
      className={classNames(
        styles.container,
        selected && styles.container_active,
        className,
      )}
    >
      <div>
        <div className={styles.container__row}>
          <p className={styles.container__text}>
            <b>Самовывоз</b>
          </p>
          <p className={styles.container__text}>
            <b>0 ₽</b>
          </p>
        </div>
      </div>
      <div className={styles.container__bottom}>
        <p className={styles.container__text}>Наш адрес:</p>
        <p className={styles.container__text}>{contacts?.address ?? ''}</p>
        <p className={styles.container__text}> {contacts?.work_time ?? ''}</p>
      </div>
    </div>
  );
};

export default CourierCard;
